export default "__VITE_ASSET__59e0b347__"